import { render, staticRenderFns } from "./PartnersDisponibles.vue?vue&type=template&id=72b74919&scoped=true&"
import script from "./PartnersDisponibles.vue?vue&type=script&lang=js&"
export * from "./PartnersDisponibles.vue?vue&type=script&lang=js&"
import style0 from "./PartnersDisponibles.vue?vue&type=style&index=0&id=72b74919&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b74919",
  null
  
)

export default component.exports